import { OtTemplateQuery } from '../../graphql-types';

export const handleOpenItineraryMap = (ot: OtTemplateQuery['ingenieOt']) => {
  const baseUrl = 'https://www.google.com/maps/dir/?api=1';
  const destination = `${ot?.localisation?.gps?.lat},${ot?.localisation?.gps?.lng}`;
  const url = `${baseUrl}&destination=${destination}`;
  window.open(url, '_blank');
};
